import React from "react";

interface Props {
  size?: number;
  color?: string;
}
export default function MoveToIcon({ size = 20, color = "#79808A" }: Props) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.81608 3.23389L7.84538 3.26416L9.66862 5.13818H16.8376C17.2893 5.13818 17.6714 5.29563 17.9762 5.60986C18.2813 5.92311 18.4332 6.31403 18.4333 6.77588V15.1284C18.4333 15.5905 18.2819 15.982 17.9772 16.2954C17.6718 16.6096 17.2893 16.7671 16.8376 16.7671H3.16178C2.71026 16.767 2.32887 16.6098 2.02409 16.2964C1.71881 15.9824 1.56705 15.5906 1.56705 15.1284V4.87158C1.56706 4.40956 1.71794 4.01794 2.02311 3.70459C2.3279 3.39041 2.71013 3.23395 3.16178 3.23389H7.81608ZM3.16178 4.38623C3.02055 4.38628 2.91104 4.43157 2.82487 4.52002C2.73838 4.60898 2.69303 4.72357 2.69303 4.87158V15.1284C2.69303 15.2764 2.73838 15.391 2.82487 15.48C2.91107 15.5685 3.02046 15.6147 3.16178 15.6147H16.8376C16.9791 15.6147 17.0892 15.5687 17.1755 15.48C17.2619 15.391 17.3073 15.2764 17.3073 15.1284V6.77588C17.3072 6.62812 17.2618 6.51415 17.1755 6.42529C17.0892 6.33655 16.9791 6.29053 16.8376 6.29053H9.21256L9.18327 6.26025L7.36002 4.38623H3.16178Z"
        fill={color}
        stroke={color}
        stroke-width="0.2"
      />
      <path
        d="M6.66667 10.8335H13.3333M13.3333 10.8335L10.4167 13.3335M13.3333 10.8335L10.4167 8.3335"
        stroke={color}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
